import {
    CLEAR_MARKETING_ADS,
    LOGOUT,
    SET_MARKETING_ADS_COMBINED,
    SET_MARKETING_ADS_FILTERS,
    SET_MARKETING_ADS_GOOGLE,
    SET_MARKETING_ADS_META,
} from './types';

export function setMarketingAdsFilters(payload) {
    return { type: SET_MARKETING_ADS_FILTERS, payload };
}

export function setMarketingAdsMeta(payload) {
    return { type: SET_MARKETING_ADS_META, payload };
}

export function setMarketingAdsGoogle(payload) {
    return { type: SET_MARKETING_ADS_GOOGLE, payload };
}

export function setMarketingAdsCombined(payload) {
    return { type: SET_MARKETING_ADS_COMBINED, payload };
}

export function clearMarketingAds() {
    return { type: CLEAR_MARKETING_ADS };
}

export { LOGOUT };
